import React, { Component } from 'react';
import ChatRoom from './ChatRoom';
import store from '../../store';

import '../../styles/chat.scss';

class Chat extends Component {
  render() {
    if (!store.getState().app.config.features.chat) {
      return <div>Chat is disabled</div>;
    }

    return (
      <div className="chat">
        <ChatRoom room="general" />
      </div>
    );
  }
}

export default Chat;
